import { AbstractMouseEvent } from './AbstractMouseEvent';
import { Mouse } from './Mouse';
import { CGSMouseEvent } from './MouseEvent';

export class MousePointerMoveEvent extends AbstractMouseEvent {
  constructor(mouse: Mouse, event: CGSMouseEvent) {
    super(mouse, event);
  }
}
